import controller from './rules.controller';

const template = require('./rules.html');

export default {
    controller,
    template
};



// WEBPACK FOOTER //
// ./app/common/rules-list/rules.component.js